import { render, staticRenderFns } from "./R24.vue?vue&type=template&id=27df158a&scoped=true"
import script from "./R24.vue?vue&type=script&lang=js"
export * from "./R24.vue?vue&type=script&lang=js"
import style0 from "./R24.vue?vue&type=style&index=0&id=27df158a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27df158a",
  null
  
)

export default component.exports